// extracted by mini-css-extract-plugin
export default {"recos":"K3-z","productCardOverride":"L3-z","rowHasBadge":"M3-z"};